"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var operators_1 = require("rxjs/operators");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var static_method_1 = require("../../utils/static-method");
var idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var CachedEntityNameProviderService = /** @class */ (function () {
    function CachedEntityNameProviderService(deService, kbService, localeService, currentLanguageProvider) {
        this.deService = deService;
        this.kbService = kbService;
        this.localeService = localeService;
        this.currentLanguageProvider = currentLanguageProvider;
        this._cache = new Map();
    }
    CachedEntityNameProviderService.prototype.getEntityName = function (categoryId, entityId, entity) {
        if (!this._cache.has(categoryId)) {
            this._cache.set(categoryId, new Map());
        }
        if (!this._cache.get(categoryId).has(entityId)) {
            this._cache.get(categoryId).set(entityId, this.loadEntityName(categoryId, entityId, entity));
        }
        return this._cache.get(categoryId).get(entityId);
    };
    CachedEntityNameProviderService.prototype.loadEntityName = function (categoryId, entityId, entity$) {
        var _this = this;
        return this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.switchMap(function (language) {
            return _this.kbService.getNameMetaFieldIds(categoryId).pipe(operators_1.map(function (nameMetaFieldIds) { return nameMetaFieldIds.map(function (value) { return value.getSystemName(); }); }), operators_1.switchMap(function (nameMetaFieldIds) {
                var entityData$ = entity$ ? Observable_1.Observable.of(entity$) : _this.deService.loadEntityByInstanceId(categoryId, entityId, false, nameMetaFieldIds);
                return entityData$.pipe(operators_1.switchMap(function (entity) {
                    return _this.kbService.getMetaFields(categoryId).pipe(operators_1.switchMap(function (fields) {
                        var nameMetaFields = fields.filter(function (value) { return nameMetaFieldIds.includes(value.getSystemName()); });
                        var names$ = nameMetaFields.map(function (nameMetaField) {
                            var metaFieldType = nameMetaField.getType();
                            var fieldValue = entity.getProperty(nameMetaField.getSystemName()).value;
                            if (metaFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE) {
                                return fieldValue ? Observable_1.Observable.fromPromise(_this.localeService.formatDate(fieldValue, language.getId())) : Observable_1.Observable.of('');
                            }
                            else if (metaFieldType === idm_kb_service_client_js_1.MetaFieldType.DATE_TIME) {
                                return fieldValue ? Observable_1.Observable.fromPromise(_this.localeService.formatDateTime(fieldValue, language.getId())) : Observable_1.Observable.of('');
                            }
                            else {
                                return Observable_1.Observable.of(static_method_1.stringifyFieldValue(metaFieldType, fieldValue, language.getId()));
                            }
                        });
                        return names$.length > 0
                            ? Observable_1.Observable.zip.apply(Observable_1.Observable, names$).map(function (names) { return names.filter(Boolean).join('/'); })
                            : Observable_1.Observable.of('');
                    }));
                }));
            }));
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    CachedEntityNameProviderService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_de_service_client_js_1.DeService, idm_kb_service_client_js_1.KbService, idm_locale_service_client_js_1.LocaleService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], CachedEntityNameProviderService);
    return CachedEntityNameProviderService;
}());
exports.CachedEntityNameProviderService = CachedEntityNameProviderService;
//# sourceMappingURL=cached-entity-name-provider.service.js.map